
import { Component, Vue, Prop } from 'vue-property-decorator';
import ReportCard from './ReportCard.vue';
import AnalystReport from './AnalystReport.vue';
import IndustryReport from './IndustryReport.vue';
import CommonDropMenu from '@/components/common/CommonDropMenu.vue';
import CommonEmpty from '@/components/common/CommonEmpty.vue';
import CommonError from '@/components/common/CommonError.vue';
@Component({
  components: {
    ReportCard,
    AnalystReport,
    IndustryReport,
    CommonDropMenu,
    CommonEmpty,
    CommonError,
  },
})
export default class Research extends Vue {
  @Prop() private reportList!: Array<object>;
  @Prop() private avatarList!: Array<object>;
  @Prop() private swiperIndex!: number;
  @Prop() private mechanismList!: Array<object>;
  @Prop() private industryList!: Array<object>;
  @Prop() private listIsLoading!: boolean;
  @Prop() private listFinished!: boolean;
  @Prop() private popupShow!: boolean;
  @Prop() private name!: string;
  @Prop() private showLoad!: boolean;
  @Prop() private showEmpty!: boolean;
  @Prop() private showError!: boolean;
  //底栏是否展示深度分析四个字
  deepReport = false;
  deep = null;
  chart = true;
  period = null;
  //控制行业研报header是否展示图表
  chart2 = false;
  //error样式
  errorStyle = {
    marginTop: '4rem',
    height: '100%',
    marginBottom: '3rem',
  };
  //空状态样式
  emptyStyle = {
    marginBottom: '3rem',
    marginTop: '4rem',
    fontFamily: 'PingFangSC-Regular',
    fontSize: '0.32rem',
    color: 'rgba(0, 0, 0, 0.84)',
    letterSpacing: 0,
    textAlign: 'center',
    lineHeight: '0.4rem',
    fontWeight: 400,
  };
  options = [
    { label: '最新', value: 0 },
    { label: '近24h最热', value: 1 },
    { label: '近1周最热', value: 2 },
    { label: '近1⽉最热', value: 3 },
    { label: '近3⽉最热', value: 4 },
  ];
  handleListLoad() {
    this.$emit('handleListLoad');
  }
  chartChange() {
    this.$emit('chartChange');
  }
  refresh() {
    this.$emit('refresh');
  }
  deepChange(val: boolean) {
    if (val) {
      this.deep = 1;
      this.deepReport = true;
      window.sessionStorage.setItem('deep', this.deep);
    } else {
      this.deep = null;
      this.deepReport = false;
      window.sessionStorage.setItem('deep', this.deep);
    }
    this.$emit('getDeep', this.deep);
  }
}
